module.exports = "/_next/static/images/3d1383e8abb525b46e71d18dd60d79e0-circles-xs.svg";